import store from '../store';

export default {
    async authentication() {
        await store.dispatch('login', '/');
    },

    async logout() {
        await store.dispatch('logout');
    }
} 